import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/auth/AuthCallback";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import AdminLogin from "@/pages/admin/AdminLogin";
import CandidatePortal from "@/pages/candidate/CandidatePortal";
import ApplicationDetail from "@/pages/candidate/ApplicationDetail";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminCandidates from "@/pages/admin/AdminCandidates";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminApplicationDetail from "@/pages/admin/AdminApplicationDetail";
import AdminOfferTemplates from "@/pages/admin/AdminOfferTemplates";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminEmailLogs from "@/pages/admin/AdminEmailLogs";
import { RouteSeo } from "@/components/shared/RouteSeo";
import AdminJobCatalog from "@/pages/admin/AdminJobCatalog";
import JobApplicationForm from "@/pages/JobApplicationForm";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <RouteSeo />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/properties/:id" element={<PropertyDetail />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/careers/:id" element={<JobDetail />} />
      <Route
        path="/careers/:id/apply"
        element={<ProtectedRoute role="candidate"><JobApplicationForm /></ProtectedRoute>}
      />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route
        path="/portal"
        element={<ProtectedRoute role="candidate"><CandidatePortal /></ProtectedRoute>}
      />
      <Route
        path="/portal/applications/:id"
        element={<ProtectedRoute role="candidate"><ApplicationDetail /></ProtectedRoute>}
      />

      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="inquiries" element={<AdminInquiries />} />
        <Route path="candidates" element={<AdminCandidates />} />
        <Route path="jobs" element={<AdminJobs />} />
        <Route path="properties" element={<AdminProperties />} />
        <Route path="applications" element={<AdminApplications />} />
        <Route path="applications/:id" element={<AdminApplicationDetail />} />
        <Route path="offer-templates" element={<AdminOfferTemplates />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="email-templates" element={<AdminEmailTemplates />} />
        <Route path="email-logs" element={<AdminEmailLogs />} />
        <Route path="job-catalog" element={<AdminJobCatalog />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
